module.exports = __webpack_public_path__ + "components/rewards/stanford-skiing/static/logo-4c0d288c3c90396005ed75421377304b.jpg";